export interface UserBase {
  id: string;
  idNumber: string;
  name: string;
  active: boolean;
  admin: boolean;
}

export const userBaseFields = `
  id
  idNumber
  name
  active
  admin
`;

export interface UserInput {
  idNumber: string;
  active?: boolean;
  admin?: boolean;
}

export const userInputFieldNames = ['idNumber', 'active', 'admin'] as const;
